import { z, ZodString } from "zod";
import { errorMessage } from "../helper/errorMessage";
import { regex } from "../helper/regex";

export const passwordValidator: ZodString = z.string().regex(regex.password, {
  message: errorMessage("invalid-password-regex"),
});
